import React from 'react';
import { Redirect } from 'react-router-dom';
import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import QuickLinkForm from './quick_link_form';
import QuickLinksService from '../../services/quick_links_service';

class QuickLinkAdd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            added: false,
            nextDisplayOrder: 0,
            localErrorMessage: null
        };
    }

    componentDidMount() {
        QuickLinksService.getAll().then(response => {
            const maxOrder = response.quickLinks.reduce((max, ql) => Math.max(max, ql.displayOrder), -1);
            this.setState({ nextDisplayOrder: maxOrder + 1 });
        }).catch(() => {
            // non-critical; new link will default to displayOrder 0
        });
    }

    handleSubmit(quickLink) {
        QuickLinksService.add({ ...quickLink, displayOrder: this.state.nextDisplayOrder }).then(() => {
            this.setState({ added: true });
        }).catch(error => {
            console.error(error);
            this.setState({ localErrorMessage: error.message });
        });
    }

    messageDismissCallback() {
        this.setState({ localErrorMessage: null });
    }

    renderMessages() {
        if (this.state.localErrorMessage) {
            return (
                <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
            );
        }
        return null;
    }

    render() {
        if (this.state.added) {
            return (
                <Redirect to={{
                    pathname: '/admin-admin/quick-links',
                    state: { from: this.props.location, successMessage: 'Quick link added.' }
                }} />
            );
        }

        return (
            <div>
                <div className="row">
                    <PageTitle title="Add Quick Link" />
                </div>
                {this.renderMessages()}
                <div className="row">
                    <QuickLinkForm onSubmit={this.handleSubmit.bind(this)} />
                </div>
            </div>
        );
    }
}

export default QuickLinkAdd;
